var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import classnames from 'classnames';
import Scroller from '../scroller';
var ChatList = (function (_super) {
    __extends(ChatList, _super);
    function ChatList(props) {
        var _this = _super.call(this, props) || this;
        _this.hasMore = true;
        _this.saveRef = function (ref) {
            if (!ref) {
                return;
            }
            _this.scroller = ref;
        };
        _this.onTop = _this.onTop.bind(_this);
        _this.onBottom = _this.onBottom.bind(_this);
        _this.state = {
            flag: true
        };
        return _this;
    }
    ChatList.prototype.componentDidMount = function () {
        this.scroller.scrollToBottom();
    };
    ChatList.prototype.componentDidUpdate = function (prevProps) {
        var prevLength = prevProps.elements.length;
        var currentLength = this.props.elements.length;
        var prevFirst = prevProps.elements[0];
        var currFirst = this.props.elements[0];
        var isFirstChanged = prevFirst && currFirst && prevFirst.key !== currFirst.key;
        if (prevLength === currentLength) {
            return;
        }
        if (isFirstChanged && currentLength > prevLength) {
            this.scroller.scrollToLastHeight();
        }
        else if (currentLength > 0) {
            if (prevProps.loadAfterMessage) {
                if (this.props.scrollToBottomFlag) {
                    this.scroller.scrollToBottom();
                }
            }
            else {
                this.scroller.scrollToBottom();
            }
        }
    };
    ChatList.prototype.onTop = function () {
        var _a = this.props, isLoading = _a.isLoading, loadMore = _a.loadMore, elements = _a.elements;
        if (!isLoading && this.hasMore && elements.length > 0) {
            loadMore();
        }
    };
    ChatList.prototype.onBottom = function () {
        var _a = this.props, isLoading = _a.isLoading, loadMore = _a.loadMore, elements = _a.elements, loadAfterMessage = _a.loadAfterMessage, changeScrollToBottomFlag = _a.changeScrollToBottomFlag;
        if (!isLoading && this.hasMore && elements.length > 0 && loadAfterMessage) {
            loadMore(true);
            changeScrollToBottomFlag(false);
        }
    };
    ChatList.prototype.render = function () {
        var _a = this.props, isLoading = _a.isLoading, className = _a.className, elements = _a.elements, loadingSpinner = _a.loadingSpinner;
        return (React.createElement(Scroller, { className: classnames('chat-list', className), customScrollBar: true, onTop: this.onTop, onBottom: this.onBottom, ref: this.saveRef },
            React.createElement("div", { className: classnames('top-holder', { invisible: !isLoading }) }, loadingSpinner),
            elements));
    };
    ChatList.defaultProps = {
        className: '',
        loadingSpinner: (React.createElement("div", null, "Loading...")),
        loadMore: function () { return; },
        isLoading: false,
        elements: [],
        loadAfterMessage: false,
    };
    return ChatList;
}(React.Component));
export default ChatList;

//# sourceMappingURL=index.js.map
